export enum FileTypes {
  EMPTY = "",
  RPLUS = "rpt",
  ADOBE = "pdf",
  BMP = "bmp",
  CSV = "csv",
  DOC = "doc",
  DOCX = "docx",
  HEIC = "heic",
  JPG = "jpg",
  JPEG = "jpeg",
  M4A = "m4a",
  MOV = "mov",
  MP3 = "mp3",
  MP4 = "mp4",
  SVG = "svg",
  TEXT = "txt",
  TIF = "tif",
  TIFF = "tiff",
  PNG = "png",
  RTF = "rtf",
  WAV = "wav",
  WAV49 = "wav49",
  WEBM = "webm",
  WEBP = "webp",
  XLS = "xls",
  XLSX = "xlsx"
}
